import { render, staticRenderFns } from "./SpringPrepositions.vue?vue&type=template&id=28a43270&scoped=true&"
import script from "./SpringPrepositions.vue?vue&type=script&lang=js&"
export * from "./SpringPrepositions.vue?vue&type=script&lang=js&"
import style1 from "./SpringPrepositions.vue?vue&type=style&index=1&id=28a43270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a43270",
  null
  
)

export default component.exports